import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { debounce } from 'utils/common';


export default function useSalaryFilter(pageSettings , setPageSettings) {
    const [searchParams, setSearchParams] = useSearchParams();
   

  const [filterLoading, setFilterLoading] = useState(false)
  const [isFilterDirty, setIsFilterDirty] = useState(false)
  const [filters, setFilters] = useState([
    {
        key: "search",
        label: "Search term",
        value: searchParams.get("search") || ""
    },
   
    {
        key: "user",
        label: "",
        value: searchParams.get("user") || ""
    },    
    {
        key: "email",
        label: "",
        value: searchParams.get("email") || ""
    },
  
  
  ]);

  useEffect(()=>{
   
        let user = []
        let employee = [...user].find(item=>item.user_id == searchParams.get("user") || "")
        let email = searchParams.get("email") || ""
    
        let _filters = [
            {
                key: "search",
                label: "Search term",
                value: searchParams.get("search") || ""
            },           
           
            {
                key: "user",
                //label: toTitleCase(employee),
                value: employee || ""
            }        ,
            {
                key: "email",
                label: "",
                value: email || ""
            }

          ]
          setFilters(_filters) 
  },[])

  const handleFilterChange =  (data, key, make_call=false) => {
    console.log( "AAAA")

    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    selectedFilter['label'] = data?.label || ""
    selectedFilter['value'] = data?.value || ""
    setFilters(_filters)
    console.log( _filters, "AAAA")
    if(make_call){
        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters

        })
    }else{
        setIsFilterDirty(true)
    }


  };
  const handleInputChange = debounce((data, key, make_call=false) => {
    console.log( "FFFF", data, key, "---HANDLE INOUT CHANGEEE")

    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    selectedFilter['label'] = key
    selectedFilter['value'] = data
    setFilters(_filters)

    if(make_call){


        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters

        })
    }else{
        setIsFilterDirty(true)
    }

  }, 1000)

  const handleDateChange = (data, key, make_call=false) => {


    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    selectedFilter['label'] = key
    selectedFilter['value'] = data
    setFilters(_filters)

    if(make_call){


        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters

        })
    }else{
        setIsFilterDirty(true)
    }

  }

  // Clear All only resets the draft fields inside the drawer - it must
  // NOT trigger a search. The actual API call happens when the user
  // clicks Apply Filter.
  const handleClearAll = () => {
    const hadValues = filters.some(filter => filter.key !== "search" && (Array.isArray(filter.value) ? filter.value.length > 0 : !!filter.value))
    let clearedFilters = filters.map(filter => ({
      ...filter,
      value: Array.isArray(filter.value) ? [] : "",
      label: filter.key === "search" ? "Search term" : ""
    }))
    setFilters(clearedFilters)
    if(hadValues){
      setIsFilterDirty(true)
    }
  }

  return {
    handleFilterChange,
    filters,
    handleInputChange,
    filterLoading, setFilterLoading,
    handleDateChange,
    handleClearAll,
    isFilterDirty, setIsFilterDirty
  };
}
